import React, { useEffect } from "react";
import Script from "next/script";
import Layout from "components/Layout";
import MarketCard from "@/components/Pages/Market/MarketCard";
import MarketContent from "@/components/Pages/Market/MarketContent";
import { get_tdk } from "api/server/tdk";
import {Util,Context} from "@xt/xtbase";
const {XtContext} = Context;
const {getOrigin} = Util;

export default function PageMarket(props) {
  const [appState] = React.useContext(XtContext);
  const {lang, theme} = appState;
  useEffect(()=>{
    if (window.zE) {
      const obj = {
        en: "en-us",
        ja: "ja",
        hi: "hi",
        id: "id",
        ru: "ru",
        es: "es-es",
        tr: "tr",
        "zh-HK": "zh-tw",
        "zh-CN": "zh-cn",
        vi: "vi",
        th: "th",
      };
      try {
        zE("webWidget", "setLocale", obj[lang] || "en-us");
      } catch (e) {}
    }
  },[]);
  return (
    <>
      <Layout isShowFoot={false}>
        {/* 顶部四个卡片暂时注释，按设计稿要求 */}
        {/* <MarketCard/> */}
        <MarketContent/>
      </Layout>
    </>
  );
}
export async function getStaticProps(context){
  const resolvedUrl = "/market";
  const props = {resolvedUrl,theme:"dark"};
  try{
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale
      },
    });
    props.tdk = tdk || {};
  }
  catch(error)
  {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }
  return {
    props,
    revalidate:60
  }
}



